var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('WebexTokenIndex',{attrs:{"routeName":_vm.$route.name}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }